import { SetEmailErrorCodeV1, SetEmailErrorV1 } from '@vista-digital/ocapi-client';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { CommonErrorCodes } from '../../../../../types/errors/common-error-codes';
import { getMember } from '../../../selectors/member/get-member';
import { LoyaltyDomainError, LoyaltyDomainSpecificErrorCode } from '../../../types/error';
import { assertIsMemberSignedIn } from '../../../utils/assert-is-member-signed-in';
import { loadMember } from '../load-member';
export const updateMemberEmail = async (emailUpdate, captchaResponse) => {
    assertIsMemberSignedIn(getMember(), 'Cannot update member email');
    try {
        await ocapiClient.instance.v1.loyalty.members.update.setEmail(emailUpdate, captchaResponse);
    }
    catch (error) {
        throw handleUpdateEmailError(error);
    }
    await loadMember(true);
};
export const handleUpdateEmailError = (error) => {
    if (!(error instanceof SetEmailErrorV1))
        throw error; // Unexpected error, rethrow immediately
    const errorCode = convertApiToDomainErrorCode(error.errorCode);
    return new LoyaltyDomainError(errorCode, error.message);
};
const convertApiToDomainErrorCode = (errorCode) => {
    switch (errorCode) {
        case SetEmailErrorCodeV1.InvalidEmail:
            return LoyaltyDomainSpecificErrorCode.InvalidEmailFormat;
        case SetEmailErrorCodeV1.InvalidCurrentPassword:
            return LoyaltyDomainSpecificErrorCode.InvalidCurrentPassword;
        case SetEmailErrorCodeV1.EmailAlreadyRegistered:
            return LoyaltyDomainSpecificErrorCode.EmailAlreadyRegistered;
        default:
            return CommonErrorCodes.UnknownError;
    }
};
